<!-- Компонент баннера технических работ — отображает уведомление о тех. работах -->
<script setup lang="ts">
import { useSettingsStore } from '@/modules/settings/store/settingsStore'
import { useI18n } from 'vue-i18n'

const settingsStore = useSettingsStore()
const { t } = useI18n()
</script>

<template>
  <div class="service-works d-flex flex-column ga-2 w-100 pa-4">
    <div class="text-h4 text-center">{{ t('common.maintenanceTitle') }}</div>
    <div class="text-body-1 text-center">
      {{ settingsStore.notificationText }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.service-works {
  border: 1px solid rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-service-works-bg), var(--v-service-works-bg-opacity));
  border-radius: 16px;
  user-select: none;
  -webkit-tap-highlight-color: transparent
}
</style>
